/**
 * SVG frame border for collection sort trigger buttons.
 */
(() => {
  function buildSortTriggerOuterPath(w, h, r) {
    const right = w - r;
    const bottom = h - r;
    return (
      "M " +
      r +
      " 0 H " +
      right +
      " C " +
      right +
      " 0 " +
      right +
      " " +
      r +
      " " +
      w +
      " " +
      r +
      " V " +
      bottom +
      " C " +
      right +
      " " +
      bottom +
      " " +
      right +
      " " +
      h +
      " " +
      right +
      " " +
      h +
      " H " +
      r +
      " C " +
      r +
      " " +
      h +
      " " +
      r +
      " " +
      bottom +
      " 0 " +
      bottom +
      " V " +
      r +
      " C " +
      r +
      " " +
      r +
      " " +
      r +
      " 0 " +
      r +
      " 0 Z"
    );
  }

  function updateSortTriggerFrame(button) {
    const svg = button.querySelector(".fcs__sort-trigger__svg");
    const path = button.querySelector(".fcs__sort-trigger__border");
    if (!svg || !path) return;

    const styles = getComputedStyle(button);
    const w = Math.max(Math.ceil(button.offsetWidth), 1);
    const h = Math.max(Math.ceil(button.offsetHeight), 1);
    const r = Math.min(
      parseFloat(styles.getPropertyValue("--fcs-sort-frame-radius")) || 10,
      w / 2,
      h / 2
    );
    const stroke =
      styles.getPropertyValue("--fcs-sort-frame-color").trim() || "#7F6D55";
    const strokeWidth =
      parseFloat(styles.getPropertyValue("--fcs-sort-frame-border-width")) || 1;

    svg.setAttribute("viewBox", "0 0 " + w + " " + h);
    path.setAttribute("d", buildSortTriggerOuterPath(w, h, r));
    path.setAttribute("stroke", stroke);
    path.setAttribute("stroke-width", String(strokeWidth));
  }

  function initSortTriggerFrames(root) {
    const scope = root && root.nodeType ? root : document;
    scope.querySelectorAll("[data-fcs-sort-frame]").forEach(updateSortTriggerFrame);
  }

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => initSortTriggerFrames(document), 120);
  });

  window.initFcsSortTriggerFrames = initSortTriggerFrames;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () =>
      initSortTriggerFrames(document)
    );
  } else {
    initSortTriggerFrames(document);
  }

  document.addEventListener("shopify:section:load", (event) => {
    initSortTriggerFrames(event.target || document);
  });
})();
